export default __webpack_public_path__ + "static/media/fastlane_detail2.06ce9c2c.jpg";